/* UserTrigger.tsx generated by @compiled/babel-plugin v0.38.1 */
// PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */
import "./UserTrigger.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  cardWrapper: "_2rko12b0 _1bsb1gwv",
  spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
export var CardWrapper = function CardWrapper(_ref) {
  var children = _ref.children,
    role = _ref.role,
    testId = _ref.testId,
    labelledBy = _ref.labelledBy;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.cardWrapper),
    backgroundColor: 'elevation.surface.overlay',
    role: role,
    testId: testId,
    "aria-labelledby": labelledBy
  }, children);
};
export var SpinnerContainer = function SpinnerContainer(_ref2) {
  var children = _ref2.children,
    testId = _ref2.testId;
  return /*#__PURE__*/React.createElement(Box, {
    testId: testId,
    xcss: cx(styles.spinnerContainer)
  }, children);
};